var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-container"},[(_vm.data)?_c('editable-list',{attrs:{"data":_vm.data,"template":_vm.template},on:{"save-parent":_vm.save}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }